// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1W9s2","signatureBlock":"Footer_signatureBlock__3ciQm","signature":"Footer_signature__1G_Qw"};